import { Paper, Stack, Typography, useTheme } from '@mui/material';
import ReactDiffViewer from 'react-diff-viewer-continued';

interface SystemLogDiffProps {
  previousObject: string;
  currentObject: string;
}

export default function SystemLogDiff({ previousObject, currentObject }: SystemLogDiffProps) {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';
  return (
    <Stack spacing={1}>
      <Typography variant="subtitle1">Event changes</Typography>
      <Paper elevation={0} sx={{ overflow: 'auto', maxHeight: 600 }}>
        <ReactDiffViewer
          hideLineNumbers
          splitView={false}
          oldValue={JSON.stringify(previousObject, null, 2)}
          newValue={JSON.stringify(currentObject, null, 2)}
          useDarkTheme={isDarkMode}
        />
      </Paper>
    </Stack>
  );
}
